// extracted by mini-css-extract-plugin
module.exports = {"signInMobileLabel":"az_OLc","fixedSignInMobileIconAndLabel":"az_PLc","signInIcon":"az_QLc"};